export enum SilkType {
  Silk = 'SILK',
  Saddlecloth = 'SADDLECLOTH',
  Both = 'BOTH',
}
